export const FLAG_GETTING_LIQUIDATION_SESSIONS =
  'FLAG_GETTING_LIQUIDATION_SESSIONS';
export const GET_LIQUIDATION_SESSIONS = 'GET_LIQUIDATION_SESSIONS';
export const CLEAR_LIQUIDATION_SESSIONS = 'CLEAR_LIQUIDATION_SESSIONS';
export const GET_LIQUIDATION_SESSION = 'GET_LIQUIDATION_SESSION';
export const CLEAR_LIQUIDATION_SESSION = 'CLEAR_LIQUIDATION_SESSION';
export const FLAG_LIQUIDATION_SESSION_ACTIVITY =
  'FLAG_LIQUIDATION_SESSION_ACTIVITY';
